define([
    // ここに書く
    'app/view/page/MonitoringPage',
    // ここまで
], function () { });